import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { HwTimeSecService } from '../../services/utils/hw-time-sec.service';
import { IOracleFee } from '../../services/wallets/utils.service';

export type FeeType = 'safe' | 'propose' | 'fast' | 'custom';
export type SelectedFee = {
    amount: string;
    priorityAmount: string;
    type: FeeType;
};

@Component({
    selector: 'app-transaction-fee',
    templateUrl: './transaction-fee.component.html',
    styleUrls: [ './transaction-fee.component.scss' ]
})
export class TransactionFeeComponent implements OnInit
{

    @Output() onChange: EventEmitter<SelectedFee> = new EventEmitter();
    @Output() onShowCustomFee: EventEmitter<SelectedFee> = new EventEmitter();

    @Input('fee-oracle') feeOracle: IOracleFee;
    @Input() symbol: string;
    @Input('default-fee') default: FeeType = 'propose';
    @Input('selected-fee') selected: FeeType = 'propose';
    @Input() baseUnit: string;
    @Input('show-custom-fee') customFee: boolean = false;
    @Input('hide-gwei') hideGwei: boolean = false;

    public selectedFee: FeeType = 'propose';
    public canShowTime: boolean = true;

    constructor(
        public hwTimeSec: HwTimeSecService
    ) { }

    ngOnInit(): void
    {
        const amounts = Object.values(this.feeOracle).map((fee) => fee.amount);
        if (amounts[ 0 ] === amounts[ 1 ] && amounts[ 1 ] === amounts[ 2 ])
        {
            this.feeOracle.propose.amount = String(Number(this.feeOracle.propose.amount) + 1);
            this.feeOracle.fast.amount = String(Number(this.feeOracle.fast.amount) + 2);
        }
        this.changeFee(this.default);

        if (this.feeOracle.fast.time === 0 || this.feeOracle.propose.time === 0 || this.feeOracle.safe.time === 0)
        {
            this.canShowTime = false;
        }
        this.selectedFee = this.selected;
        this.onChange.emit({ amount: this.feeOracle[ this.selectedFee ]?.amount, priorityAmount: this.feeOracle[ this.selectedFee ]?.priorityAmount, type: this.selectedFee });
    }

    public changeFee(_feeType: FeeType)
    {
        this.selectedFee = _feeType;
        this.onChange.emit({ amount: this.feeOracle[ _feeType ]?.amount, priorityAmount: this.feeOracle[ _feeType ]?.priorityAmount, type: _feeType });
    }

    public viewCustomFee()
    {
        this.selectedFee = 'custom';
        this.onShowCustomFee.emit();
    }
}
